export const MyAccount = () => <h2>MyAccount</h2>;